export default __webpack_public_path__ + "static/media/stand_facing_camera.5d27e400.mp3";